var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtuals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5834 0 0 3.5834 0 8C0 12.4166 3.5834 16 8 16C12.4166 16 16 12.4166 16 8C16 3.5834 12.4166 0 8 0ZM5.93395 1.57832L5.60203 2.1812L8 3.21761L10.398 2.1812L10.066 1.57832C11.4479 2.0254 12.6266 2.90601 13.4598 4.05758L12.7756 3.9221L12.5385 6.51651L14.2591 8.48772L14.7468 7.95936V8C14.7468 9.49704 14.2523 10.8789 13.4191 12.0034L13.3378 11.2989L10.7976 11.8679L9.46994 14.1101L10.0931 14.4014C9.4293 14.6181 8.71803 14.7536 7.98645 14.7536C7.25487 14.7536 6.54361 14.6181 5.87976 14.4014L6.50296 14.1101L5.17527 11.8679L2.63506 11.2989L2.55377 12.0034C1.72058 10.8789 1.22608 9.50381 1.22608 8V7.95936L1.7138 8.48772L3.43438 6.51651L3.19729 3.9221L2.51312 4.05758C3.34632 2.90601 4.52498 2.0254 5.90686 1.57832H5.93395ZM8 5.33108L5.18882 7.38357L6.2591 10.6825H9.73412L10.8044 7.38357L7.99323 5.33108H8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtuals);
export default __webpack_public_path__ + "static/media/virtuals.030886bdd2555507331e2ba12a44f59b.svg";
export { ForwardRef as ReactComponent };